"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlansWithHigherLimit = void 0;
const getPlansWithHigherLimit = ({ currentLimit, limitName, plans, }) => {
    if (currentLimit.isUnlimited) {
        return plans.filter((plan) => limitName in plan.limits && plan.limits[limitName].isUnlimited);
    }
    return plans.filter((plan) => limitName in plan.limits &&
        (plan.limits[limitName].isUnlimited ||
            plan.limits[limitName].value > currentLimit.value));
};
exports.getPlansWithHigherLimit = getPlansWithHigherLimit;
